<template>
    <div
        class="justify-between flex-grow max-h-full"
      >
        <div class="flex h-full gap-4 flex-1 overflow-y-auto">
          <div
            class="w-2/12 rounded-xl self-start bg-white shadow flex flex-col gap-x-4 shrink-0 overflow-y-auto scroll-bar"
          >
            <div
              class="px-4 py-3 transition-all relative duration-200 items-center text-sm font-medium flex gap-3 cursor-pointer bg-primary text-white-text"
            >
              <!-- :style="{borderColor: currentTab === nav.nav ? '#cdcdcd': '' }" -->
              <font-awesome-icon :icon="['far', 'file-lines']" />
              {{ $t('pages.tenant_packages.refreshing_workflow_detail') }}
              <!-- <font-awesome-icon class="text-gray-500 absolute right-2" v-if="currentTab === nav.nav" icon="arrow-right" /> -->
            </div>
          </div>
          <div class="flex-col w-full">
            <div
              class="px-4 lg:px-5 py-3 flex gap-3 items-center bg-primary border-b border-gray-200 text-white-text text-lg font-medium rounded-t-xl"
            >
              <span class="font-bold">{{ $t('pages.tenant_packages.refreshing_workflow_detail') }} </span>
            </div>

            <div :class="'p-3 flex pb-4 overflow-y-auto scroll-bar'" 
              style="height: calc(100% - 54px)">
                <CreateWorkflow isRevetting :revettingWorkflowDetail="revettingWorkflowDetail"/>
            </div>
          </div>
        </div>
      </div>
</template>

<script>
import CreateWorkflow from "@shared/workflow/components/create-workflow.vue";

export default {
  name: 'RevettingWorkflow',
  components: {
    CreateWorkflow,
  },
  props: {
    revettingWorkflowDetail: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>